export class TimeModel {

  constructor(
    public hour: number,
    public minute: number
  ) {  }
}
